import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Brand } from '../model'

export const initialState = Brand.masmovil

const brandSlice = createSlice({
  name: 'brand',
  initialState,
  reducers: {
    changeBrand: (state, action: PayloadAction<Brand>) => action.payload,
  },
})

export const { changeBrand } = brandSlice.actions

const brandReducer = brandSlice.reducer
export default brandReducer
